export const ENTRY_ID = '2fjaO4JP4UKru0YRy1SAvh'
export const QUERY_TYPE = 'dashboardProgram'
export const SUBHEADER_TEXT = 'Preview Program Pathways and Resources'
